exports = module.exports = require("../../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-radi {\n  border-radius: 10px 10px 10px 10px;\n}\n\n.fs-icon {\n  font-size: 5.5rem\n}\n\n.foot-card {\n  color: gray;\n  opacity: 0.7;\n  cursor: pointer;\n}\n\n.foot-card:hover {\n  transition: 0.5s;\n  color: black;\n  opacity: 1;\n}\n\n.box-dash-one {\n  color: white;\n  border-radius: 5px 5px 0px 0px;\n  background-image: linear-gradient(90deg, #40dcb2, #40dc7e);\n  box-shadow: 0 0 0 0 #db9d00, 0 0 0 0 #ffb600;\n}\n\n.box-dash-two {\n  color: white;\n  border-radius: 5px 5px 0px 0px;\n  background-image: linear-gradient(90deg, #fc0, #ffa100);\n  box-shadow: 0 0 0 0 #db9d00, 0 0 0 0 #ffb600;\n}\n\n.box-dash-three {\n  color: white;\n  border-radius: 5px 5px 0px 0px;\n  background-image: linear-gradient(90deg, #4cc4ff, #4ca6ff);\n  box-shadow: 0 0 0 0 #419cdb, 0 0 0 0 #4cb5ff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/dashbroad/dashbroad.component.css
// module id = ../../../../../src/app/admin/page/dashbroad/dashbroad.component.css
// module chunks = main